<template>
  <v-container fluid fill-height>
    <v-layout wrap>
      <v-flex>
        <v-card class="elevation-4">
          <v-card-text>
            <p class="mb-6">
              <span class="font-weight-bold">{{ approvalStatusInBahasa }}</span>
              oleh <span class="font-weight-bold">{{ by }}</span> pada waktu
              <span class="font-weight-bold">{{ lastUpdatedDateTime }}</span>
            </p>
            <v-textarea
              label="Komentar Respon"
              hint="komentar dari responden sebelumnya"
              persistent-hint
              readonly
              filled
              v-if="canSeeComment"
              v-model="comment"
            ></v-textarea>
            <v-textarea
              class="mt-4"
              label="Komentar Anda"
              outlined
              hint="komentar untuk dibaca oleh responden"
              persistent-hint
              v-if="canComment"
              v-model="replyComment"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-3" :to="backPath" dark
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="review"
                    v-if="canBeReviewed"
                    >Kunci untuk review<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >

                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="revisionNeeded"
                    class="mr-3"
                    v-if="canBeMarkedRevisionNeeded"
                    >Butuh revisi<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >

                  <v-btn
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                    @click="approve"
                    v-if="canBeApproved"
                    class="mr-3"
                    >Setujui<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >

                  <v-btn
                    color="error"
                    :loading="loading"
                    :disabled="loading"
                    @click="reject"
                    v-if="canBeRejected"
                    >Tolak<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >

                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="revise"
                    v-if="canBeRevised"
                    >Ajukan Revisi<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["entrancePackageId"],
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      comment: null,
      replyComment: null,
      approvalStatus: null,
      approvalStatusInBahasa: null,
      by: null,
      lastUpdatedDateTime: null,
      mainPath: process.env.VUE_APP_ENTRANCEPACKAGE_APPROVAL_PATH,
      backPath: process.env.VUE_APP_ENTRANCEPACKAGE_PATH,
      reviewPath: process.env.VUE_APP_ENTRANCEPACKAGE_APPROVAL_REVIEW_PATH,
      revisionNeededPath:
        process.env.VUE_APP_ENTRANCEPACKAGE_APPROVAL_REVISION_NEEDED_PATH,
      revisePath: process.env.VUE_APP_ENTRANCEPACKAGE_APPROVAL_REVISE_PATH,
      approvePath: process.env.VUE_APP_ENTRANCEPACKAGE_APPROVAL_APPROVE_PATH,
      rejectPath: process.env.VUE_APP_ENTRANCEPACKAGE_APPROVAL_REJECT_PATH
    };
  },
  methods: {
    fetchData() {
      let self = this;
      this.axios
        .get(self.mainPath + "/" + this.entrancePackageId)
        .then(function(response) {
          let data = response.data;
          self.comment = data.comment;
          self.approvalStatus = data.approvalStatus;
          self.approvalStatusInBahasa = data.approvalStatusInBahasa;
          self.by = data.by;
          self.lastUpdatedDateTime = data.lastUpdatedDateTime;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    review() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.reviewPath + "/" + this.entrancePackageId)
        .then(function() {
          self.fetchData();
          self.loadingMessage =
            "Sukses mengunci paket  bermain masuk untuk direview";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    revisionNeeded() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.revisionNeededPath, {
          comment: self.replyComment,
          entrancePackageId: self.entrancePackageId
        })
        .then(function() {
          self.fetchData();
          self.loadingMessage = "Sukses menandai paket bermain butuh direvisi";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    revise() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.revisePath, {
          comment: self.replyComment,
          entrancePackageId: self.entrancePackageId
        })
        .then(function() {
          self.fetchData();
          self.loadingMessage = "Sukses mengajukan revisi paket bermain";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    approve() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.approvePath, {
          comment: self.replyComment,
          entrancePackageId: self.entrancePackageId
        })
        .then(function() {
          self.fetchData();
          self.loadingMessage = "Sukses menyetujui paket bermain ini";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    reject() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      this.axios
        .post(self.rejectPath, {
          comment: self.replyComment,
          entrancePackageId: self.entrancePackageId
        })
        .then(function() {
          self.fetchData();
          self.loadingMessage = "Sukses menolak paket bermain ini";
          self.loadingMessageColor = "primary";
          self.$vuetify.goTo(0, self.successScrollOptions);
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    }
  },
  computed: {
    accessedByAdmin() {
      let keycloak = this.$keycloak;
      let roles = keycloak.realmAccess.roles;
      return roles.includes("ADMIN");
    },
    accessedBySuperAdmin() {
      let keycloak = this.$keycloak;
      let roles = keycloak.realmAccess.roles;
      return roles.includes("SUPERADMIN");
    },
    canBeReviewed() {
      return this.accessedBySuperAdmin && this.approvalStatus === "INITIATED";
    },
    canBeRevised() {
      return this.accessedByAdmin && this.approvalStatus === "REVISION_NEEDED";
    },
    canBeMarkedRevisionNeeded() {
      return (
        this.accessedBySuperAdmin &&
        (this.approvalStatus === "REVIEWING" ||
          this.approvalStatus === "REVISED" ||
          this.approvalStatus === "APPROVED")
      );
    },
    isNotLockedForEdit() {
      return (
        this.approvalStatus === "REVIEWING" || this.approvalStatus === "REVISED"
      );
    },
    canBeApproved() {
      return this.accessedBySuperAdmin && this.isNotLockedForEdit;
    },
    canBeRejected() {
      return this.accessedBySuperAdmin && this.isNotLockedForEdit;
    },
    canBeRevisedAfterApproved() {
      return this.accessedBySuperAdmin && this.approvalStatus === "APPROVED"
    },
    canComment() {
      return (
        this.canBeRevised ||
        (this.accessedBySuperAdmin && this.isNotLockedForEdit) ||
        (this.canBeRevisedAfterApproved)
      );
    },
    canSeeComment() {
      return (
        this.approvalStatus !== "INITIATED" &&
        this.approvalStatus !== "REVIEWING"
      );
    }
  },
  mounted: function() {
    // this.entrancePackageId = this.$route.params.id;
    this.fetchData();
  }
};
</script>

<style></style>
